import {RowModel} from 'notebook/tables/store/models/RowModel';

export type RowSelectionRange = Pick<RowModel, 'selectedColIndexMin' | 'selectedColIndexMax'>;

function isRowSelected(rowModel: RowSelectionRange): boolean {
  return rowModel.selectedColIndexMin != null && rowModel.selectedColIndexMax != null;
}

export function isCellSelected(rowModel: RowSelectionRange, j: number): boolean {
  return (
    isRowSelected(rowModel) &&
    (rowModel.selectedColIndexMin || 0) <= j &&
    j <= (rowModel.selectedColIndexMax || 0)
  );
}
